import gql from 'graphql-tag';

export const CLIENT_GROUP_FRAGMENT = gql`
  fragment ClientGroupFragment on ClientGroup {
    id
    organizationId
    name
  }
`;
